// extracted by mini-css-extract-plugin
export default {"Header":"RatingView_Header__z4X6V","Label":"RatingView_Label__vKn8U","NotUseButton":"RatingView_NotUseButton__adwiv","UseButton":"RatingView_UseButton__31zrg"};